export default __webpack_public_path__ + "static/media/Level4.29f33839.svg";